import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { addUser, searchFilter } from "../redux/shopSlice";

function Header() {
  const loco = useLocation().pathname;
  console.log(loco);
  const dispatch = useDispatch()
  
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      // There's a user object in localStorage, set the user object to state
      dispatch(
        addUser({
          _id: storedUser.uid,
          name: storedUser.displayName,
          email: storedUser.email,
          image: storedUser.photoURL,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //SEARCH TOGGLE
  const searchBar = useSelector((state)=> state.shopsyReducer.toggleOn)?true:false;
  const [ enableSearch, setEnableSearch ] = useState();
  const [ inHome, setInHome ] = useState(false)
  
    useEffect(()=>{
      if(loco==="/"){
      setInHome(true)
    }else{
      setInHome(false)
    }
    },[loco])
    console.log("ih",inHome, searchBar)
  useEffect(()=>{
    setEnableSearch(searchBar?searchBar:false);
    console.log('Hi',searchBar);
    
  },[searchBar])
  

  const [query,setQuery] = useState();
  console.log("Query: "+ query);
  dispatch(searchFilter({
    input: query,
    length: query ? query.length :0
  }))
  const userInfo = useSelector((state)=> state.shopsyReducer.userInfo);
  
  console.log(enableSearch);
  return (
    <div className="w-full h-16 bg-slate-900 border-b-[1px] border-b-purple-600 flex mx-auto justify-between sticky z-50 fixed top-0">
      <div className="max-w-screen-x1 h-full  items-center  py-3 pl-3">
        <div>
          <Link to={"/"} className="cursor-default">
            <img
              src="https://lh3.googleusercontent.com/a/AGNmyxYQYg5yNpuJSK80rso8RGdyujuKETOpDNAwegW4=s288"
              alt="LoGo"
              className="active:scale-95 w-10 opacity-90 mb-5 rounded-full"
            />
          </Link>
        </div>
      </div>

      <div>
        {/* SearcH */}
        {enableSearch && inHome ? (
          <div className="max-w-md mx-auto p-3">
            <div className="relative flex items-center w-full h-10 rounded-lg focus-within:shadow-lg bg-white overflow-hidden">
              <div className="grid place-items-center h-full w-12 text-gray-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>

              <form action="">
                <input
                  onChange={(e) => {
                    setQuery(e.target.value);
                  }}
                  autoFocus
                  className="peer h-full w-full outline-none text-sm text-gray-700"
                  type="text"
                  id="search"
                  placeholder="Search something.."
                />
              </form>
            </div>
          </div>
        ) : (
          <p className="h-16 pt-4">
            <span className="self-center text-2xl font-extrabold whitespace-nowrap text-yellow-500 tracking-wider font-bodyFont">
              SHOPSYi
            </span>
          </p>
        )}
      </div>

      <div>
        <Link to={"/login"} className="cursor-default">
          {userInfo ? (
            <div className="pr-3 py-2">
              <img
                src={userInfo.image}
                alt="UserLogo"
                className="active:scale-95 w-10 mt-1 opacity-90 rounded-full"
              />
            </div>
          ) : (
            <img
              src="https://icons.veryicon.com/png/o/business/multi-color-financial-and-business-icons/user-139.png"
              alt="UserLogo"
              className="active:scale-95 w-12  py-3 pr-2  opacity-90 rounded-full"
            />
          )}
        </Link>
      </div>
    </div>
  );
}

export default Header;
